import {Link} from "react-router-dom";
import {useI18n} from "./I18nProvider";
import {HOME_DEPARTMENTS} from "./homeDepartments";

function DepartmentCard({dept}: {dept: typeof HOME_DEPARTMENTS[number]}) {
  const {t} = useI18n();
  const soon = dept.status === "coming_soon";
  const body = (
    <article
      className={`cc-deptCard${soon ? " cc-deptCard--soon" : ""}`}
      style={{backgroundColor: dept.cardBg}}
      aria-disabled={soon ? true : undefined}
    >
      <div className="cc-deptCard__top">
        <div className="cc-deptCard__brand">
          <span className="cc-deptCard__brandName">Zaaaz</span>
          <span className="cc-deptCard__brandDept">{t(dept.nameKey)}</span>
        </div>
        <p className="cc-deptCard__desc">{t(dept.descriptionKey)}</p>
        {soon ? (
          <span className="cc-deptCard__badge">{t("Home departments coming soon")}</span>
        ) : dept.hubPath ? (
          <span className="cc-deptCard__cta">{t("Home department view cta")}</span>
        ) : null}
      </div>
      <div className="cc-deptCard__visualWrap" style={{backgroundColor: dept.cardBg}}>
        <img
          src={dept.cardImage}
          alt=""
          className="cc-deptCard__visual"
          loading="lazy"
          decoding="async"
        />
      </div>
    </article>
  );
  if(dept.hubPath && !soon) {
    return (
      <Link to={dept.hubPath} className="cc-deptCard__link anim">
        {body}
      </Link>
    );
  }
  return <div className="cc-deptCard__link cc-deptCard__link--static">{body}</div>;
}

export function HomeDepartments() {
  const {t} = useI18n();
  return (
    <section className="cc-homeDepartments" aria-labelledby="home-departments-title">
      <div className="cc-homeDepartments__head">
        <h2 id="home-departments-title" className="cc-homeDepartments__title">
          {t("Home departments title")}
        </h2>
        <p className="cc-homeDepartments__subtitle">{t("Home departments subtitle")}</p>
      </div>
      <div className="cc-deptStrip">
        <div className="cc-deptStrip__track">
          {HOME_DEPARTMENTS.map((dept) => (
            <DepartmentCard key={dept.id} dept={dept} />
          ))}
        </div>
      </div>
    </section>
  );
}
